import { Navigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userProfile } from "../../state/actions/accountActions";
import Header from "../Header";
import { useEffect, useState } from "react";

const MANAGER_ROLES = ["menadzer", "rukovodilac"];

const ManagerRoute = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    dispatch(userProfile())
      .then(setUser)
      .finally(() => setIsLoading(false));
  }, [dispatch, location.pathname]);

  if (isLoading) {
    return null;
  }

  if (!user || !MANAGER_ROLES.includes(user.role)) {
    const redirectTo = user?.role === "agent" ? "/home" : "/login";
    return <Navigate to={redirectTo} state={{ from: location }} replace />;
  }

  return (
    <>
      <Header />
      {children}
    </>
  );
};

export default ManagerRoute;
